module.exports = __webpack_public_path__ + "img/icon_camera.0a537453.svg";